/**
 * Fetch personalized product alternatives for PDP teaser.
 */

import api from "./api/axiosInstance";
import { getMatchExplanationBody } from "./fetchProductMatchExplanation";

/**
 * @param {string} productId
 * @param {Object} options - { user, limit, body }
 */
export async function fetchProductAlternatives(productId, options = {}) {
  if (!productId) return null;

  const limit = options.limit ?? 3;
  const   body =
    options.body !== undefined
      ? options.body
      : getMatchExplanationBody(options.user, {
          aiSession: options.aiSession,
        });

  const hasBody = body && Object.keys(body).length > 0;
  const config = { params: { limit } };

  try {
    const res = hasBody
      ? await api.post(`/products/${productId}/alternatives`, body, config)
      : await api.get(`/products/${productId}/alternatives`, config);

    return res.data || null;
  } catch {
    return null;
  }
}

export default fetchProductAlternatives;
